import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLoading } from '@/contexts/LoadingContext'
import { useForgotPassword } from '@/hooks/useAuth'

import { ForgotPasswordForm } from './ForgotPasswordForm'
import { ForgotPasswordSuccess } from './ForgotPasswordSuccess'

interface ForgotPasswordData {
  email: string
}

export function ForgotPassword() {
  const { t } = useTranslation()
  const {
    isLoading,
    error,
    emailSent,
    submittedEmail,
    resetToken,
    handleSubmit,
    handleResend,
  } = useForgotPassword()
  const { showLoading, hideLoading } = useLoading()

  useEffect(() => {
    if (isLoading) {
      showLoading(t('auth.sendingResetLink'))
    } else {
      hideLoading()
    }
  }, [isLoading, showLoading, hideLoading, t])

  const onSubmit = async (data: ForgotPasswordData) => {
    await handleSubmit(data.email)
  }

  if (emailSent) {
    return (
      <ForgotPasswordSuccess
        email={submittedEmail}
        onResend={handleResend}
        resetToken={resetToken}
      />
    )
  }

  return (
    <ForgotPasswordForm
      onSubmit={onSubmit}
      isLoading={isLoading}
      error={error || undefined}
    />
  )
}
